import { useState } from 'react';

const DISTANCES = {
  nextGen: {
    vancouver: 1160,
    calgary: 300,
    regina: 781,
    winnipeg: 1307,
    toronto: 30,
    montreal: 532,
    fredericton: 1340,
    halifax: 1769,
  },
  mineralWool: {
    vancouver: 523,
    calgary: 702,
    regina: 1245,
    winnipeg: 1821,
    toronto: 54,
    montreal: 610,
    fredericton: 1416,
    halifax: 1845,
  },
};

const NUMBER_OF_TRUCKS_FACTOR = {
  nextGen: 99840,
  mineralWool: 21504,
};

const useQuietZoneCalculator = ({ formValues, setFormValues, locale }) => {
  const [results, setResults] = useState();

  const { code = 'en-CA' } = locale || {};

  const onChangeInput = e => {
    const { name, value } = e.target;

    if (name === 'projectSqFoot') {
      setFormValues(prevValues => ({
        ...prevValues,
        [name]: value.replaceAll(/[^0-9]/g, ''),
      }));
    } else {
      setFormValues(prevValues => ({
        ...prevValues,
        [name]: value,
      }));
    }
  };

  const resetForm = () => {
    setFormValues({
      projectLocation: '',
      projectSqFoot: '',
    });
    setResults(undefined);
  };

  const isFormValid = !!(formValues.projectLocation && formValues.projectSqFoot);

  const onCalculate = e => {
    e.preventDefault();

    const { projectSqFoot, projectLocation } = formValues;

    const numberOfTrucks = type => Math.ceil(projectSqFoot / NUMBER_OF_TRUCKS_FACTOR[type]);

    const bearWeight = 300; // Average weight of a bear in pounds
    const mooseWeight = 1; // Average weight of a moose in tons
    const nextGen = {
      bagsInsulationRequired: Math.ceil(projectSqFoot / 128),
      poundsFiberUsed: projectSqFoot * 0.23,
      metricTonsFiberUsed: (projectSqFoot * 0.23) / 2000,
      tonsCO2Emitted: (numberOfTrucks('nextGen') * (DISTANCES.nextGen[projectLocation] * 0.7852)) / 1000,
    };
    const mineralWool = {
      bagsInsulationRequired: Math.ceil(projectSqFoot / 64),
      poundsFiberUsed: projectSqFoot * 0.73,
      metricTonsFiberUsed: (projectSqFoot * 0.73) / 2000,
      tonsCO2Emitted: (numberOfTrucks('mineralWool') * (DISTANCES.mineralWool[projectLocation] * 0.7852)) / 1000,
    };
    const tonsCO2Saved =
      mineralWool.tonsCO2Emitted - nextGen.tonsCO2Emitted > 0 ? mineralWool.tonsCO2Emitted - nextGen.tonsCO2Emitted : 0;

    setResults({
      projectSqFoot,
      nextGen: {
        bagsInsulationRequired: nextGen.bagsInsulationRequired.toLocaleString(code),
        poundsFiberUsed: nextGen.poundsFiberUsed.toLocaleString(code, { maximumFractionDigits: 2 }),
        metricTonsFiberUsed: nextGen.metricTonsFiberUsed.toLocaleString(code, { maximumFractionDigits: 2 }),
        tonsCO2Emitted: nextGen.tonsCO2Emitted.toLocaleString(code, { maximumFractionDigits: 2 }),
      },
      mineralWool: {
        bagsInsulationRequired: mineralWool.bagsInsulationRequired.toLocaleString(code),
        poundsFiberUsed: mineralWool.poundsFiberUsed.toLocaleString(code, { maximumFractionDigits: 2 }),
        metricTonsFiberUsed: mineralWool.metricTonsFiberUsed.toLocaleString(code, { maximumFractionDigits: 2 }),
        tonsCO2Emitted: mineralWool.tonsCO2Emitted.toLocaleString(code, { maximumFractionDigits: 2 }),
      },
      savings: {
        bagsInsulationRequired: (mineralWool.bagsInsulationRequired - nextGen.bagsInsulationRequired).toLocaleString(
          code,
          {
            maximumFractionDigits: 2,
          }
        ),
        total: (projectSqFoot * 1.23).toLocaleString(code, { maximumFractionDigits: 2 }),
        bears: Math.ceil((mineralWool.poundsFiberUsed - nextGen.poundsFiberUsed) / bearWeight),
        mooses: Math.ceil((mineralWool.metricTonsFiberUsed - nextGen.metricTonsFiberUsed) / mooseWeight),
        gasoline: Math.ceil(tonsCO2Saved * 426),
        poundsFiber: (mineralWool.poundsFiberUsed - nextGen.poundsFiberUsed).toLocaleString(code, {
          maximumFractionDigits: 2,
        }),
        metricTonsFiber: (mineralWool.metricTonsFiberUsed - nextGen.metricTonsFiberUsed).toLocaleString(code, {
          maximumFractionDigits: 2,
        }),
        tonsCO2: tonsCO2Saved.toLocaleString(code, {
          maximumFractionDigits: 2,
        }),
      },
    });
  };

  return {
    formValues,
    onChangeInput,
    resetForm,
    isFormValid,
    onCalculate,
    results,
  };
};

export default useQuietZoneCalculator;
